import * as React from "react"
import { Col, Hidden, Row, Visible } from "react-grid-system"
import styled from "styled-components"
import { HorizontalSpacer } from "../atoms/spacers"
import { theme } from "../theme"
import { MediaQuery } from "../../utils/design-helpers"
import ProfileImage from "../atoms/ProfileImage"
import H3 from "../atoms/typography/H3"
import SmallButton from "../atoms/buttons/SmallButton"
import { ArrowDropDownIcon } from "../atoms/icons/ArrowDropDownIcon"
import { ArrowDropUpIcon } from "../atoms/icons/ArrowDropUpIcon"
import Body from "../atoms/typography/Body"

interface MemberDropdownBarProps {
  imgSrc: string
  name: string
  title: string
  suborg: string
  role: string
  open: boolean
  onClick: () => void
  myOrgName: string
  email: string
}

const BarContainer = styled(Row)<{ open: boolean }>`
  padding: ${(props) => props.theme.spacings.large};
  border-radius: ${(props) => props.theme.borders.softRadius};
  background-color: ${(props) => (props.open ? props.theme.colors.greyLight : props.theme.colors.white)};

  :hover {
    ${MediaQuery.LG} {
      background-color: ${(props) => props.theme.colors.greyLight};
    }

    :hover .hiddentitle {
      ${MediaQuery.LG} {
        display: block;
      }
    }
  }
`

const TitleHiddenDisplayOnHover = styled.div`
  display: none;
`

const MemberDropdownBar: React.FunctionComponent<MemberDropdownBarProps> = ({
  imgSrc,
  name,
  title,
  suborg,
  role,
  open,
  onClick,
  myOrgName,
  email,
}) => {
  const buttonIcon = open ? (
    <ArrowDropUpIcon color={theme.colors.greyDark} />
  ) : (
    <ArrowDropDownIcon color={theme.colors.greyDark} />
  )

  return (
    <BarContainer open={open} align="center">
      <Col md={4} xs={2}>
        <Row align="center">
          <ProfileImage src={imgSrc} alt={`Profile image ${name}`} />
          <Hidden xs>
            <div>
              <Body>{name}</Body>
              <Body color={theme.colors.greyPlaceholder}>{email}</Body>
            </div>
          </Hidden>
        </Row>
      </Col>
      <Visible xs>
        <Col xs={9}>
          <Body>{name}</Body>
          <HorizontalSpacer spacing={1} />
          <div>
            <Body>
              {title} / {role}
            </Body>
          </div>
        </Col>
      </Visible>
      <Hidden xs>
        <Col md={2}>
          <Row>
            <div>
              <TitleHiddenDisplayOnHover className="hiddentitle">
                <Body>Title:</Body>
              </TitleHiddenDisplayOnHover>
              <Body>{title}</Body>
            </div>
          </Row>
        </Col>
        <Col md={2}>
          <Row>
            <div>
              {myOrgName !== suborg && (
                <TitleHiddenDisplayOnHover className="hiddentitle">
                  <Body>Suborganization:</Body>
                </TitleHiddenDisplayOnHover>
              )}
              <Body>{suborg}</Body>
            </div>
          </Row>
        </Col>
        <Col md={2}>
          <Row>
            <div>
              <TitleHiddenDisplayOnHover className="hiddentitle">
                <Body>Organization role:</Body>
              </TitleHiddenDisplayOnHover>
              <Body>{role}</Body>
            </div>
          </Row>
        </Col>
      </Hidden>
      <Visible xs>
        <div onClick={onClick}>{open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</div>
      </Visible>
      <Hidden xs>
        <Col md={2}>
          <Row justify="end">
            <SmallButton title={open ? "Hide" : "Show"} icon={buttonIcon} onClick={onClick} />
          </Row>
        </Col>
      </Hidden>
    </BarContainer>
  )
}

export default MemberDropdownBar
